// components/Hero.jsx

import React from "react";
import styles from "../styles/Hero.module.css";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../images/mesogeios-restaurant.jpg";

export default function Hero() {

  const navigate = useNavigate();

  const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

  return (
    <section className={styles.hero} id="home" style={{backgroundImage: `url(${backgroundImage})`}}>
      
      {/* Dark Overlay */}
      <div className={styles.overlay}></div>

      {/* Content */}
      <div className={styles.content}>
        <h2 className={styles.subtitle}>
          Authentic Mediterranean Cuisine
        </h2>

        <h1>
          Welcome to <br />
          Mesogeios
        </h1>

        <p>
          Experience Mediterranean tastes, fresh local ingredients, and unforgettable
          moments in the heart of Corfu.
        </p>

        <div className={styles.buttons}>
          <button onClick={() => scrollToSection('menu')} className={styles.primaryBtn}>
            Explore Menu
          </button>

          <button onClick={() => navigate('/reservation')} className={styles.secondaryBtn}>
            Reserve Table
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className={styles.scroll}>
        <span></span>
      </div>
    </section>
  );
}